import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, signal } from '@angular/core';
import { ITableColumn } from 'src/app/core/models/table.model';
import { PageListComponent } from 'src/app/layout/pages/page-list/page-list.component';
import { PARAMETRI_COLUMNS, PARAMETRI_QUERY_SERVICE_INSTANCE, PARAMETRI_VISIBLECOLUMNS } from '../parametri.config';
import { QueryService } from 'src/app/core/services/query.service';
import { IParametro } from '../parametri.model';
import { ParametriService } from '../parametri.service';
import { NewFormComponent } from '../components/new-form/new-form.component';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-parametri-lista-page',
  standalone: true,
  imports: [
    CommonModule,
    PageListComponent,
    NewFormComponent
  ],
  templateUrl: './lista-page.component.html',
  styleUrl: './lista-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListaPageComponent {
  data = this.queryService.store.selectKey('list');
  columns: ITableColumn[] = PARAMETRI_COLUMNS;
  visibleColumns = signal(PARAMETRI_VISIBLECOLUMNS);
  insertForm: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    @Inject(PARAMETRI_QUERY_SERVICE_INSTANCE) public readonly queryService: QueryService<IParametro>,
    public readonly service: ParametriService,
  ) {
    this.insertForm = this.fb.group({})
  }
}
